import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum, getCommonItem } from '@systemeio/digital-store-shared';
import { FormInput } from '@systemeio/ui';
import StoreFields from 'modules/stores/store/components/contact-fields';
import ItemSteps from 'modules/stores/store/components/item-steps';
import StoreImageSelector from 'modules/stores/store/components/store-image-selector';
import { OptinItemEditType, OptinItemErrorsType } from 'modules/stores/store/content/optin/types/optin-interface';
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context';
import React, { Dispatch, FC, SetStateAction, useEffect } from 'react';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { optinInitFields } from '../constants/mandatory-fields';
interface OptinThumbnailProps {
  tempState: OptinItemEditType;
  setTempState: Dispatch<SetStateAction<OptinItemEditType>>;
  errors: OptinItemErrorsType;
}
const OptinThumbnail: FC<OptinThumbnailProps> = t0 => {
  const $ = _c(70);
  const {
    tempState,
    setTempState,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    setPreview,
    setSingleItemMode
  } = useStorePreviewContext();
  let t1;
  let t2;
  if ($[0] !== setPreview || $[1] !== setSingleItemMode || $[2] !== tempState) {
    t1 = () => {
      setPreview([getCommonItem(tempState)]);
      setSingleItemMode(true);
    };
    t2 = [setPreview, setSingleItemMode, tempState];
    $[0] = setPreview;
    $[1] = setSingleItemMode;
    $[2] = tempState;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.store.image.select_image");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = tempState.thumbnail;
  let t5;
  if ($[7] !== t) {
    t5 = t("dashboard.store.image.thumbnail");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== setTempState) {
    t6 = dataFile => setTempState(prev => ({
      ...prev,
      thumbnail: dataFile
    }));
    $[9] = setTempState;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== tempState.thumbnail) {
    t7 = <StoreImageSelector dataFile={t4} imageType={StoreImageEnum.optin_thumbnail} label={t5} onChange={t6} />;
    $[11] = t5;
    $[12] = t6;
    $[13] = tempState.thumbnail;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = {
      key: "image",
      title: t3,
      element: t7
    };
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("dashboard.store.item.add_text");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = tempState.title;
  let t11;
  if ($[20] !== t) {
    t11 = t("dashboard.store.item.title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== setTempState) {
    t12 = t13 => {
      const {
        target: t14
      } = t13;
      const {
        value
      } = t14;
      return setTempState(prev_0 => ({
        ...prev_0,
        title: value
      }));
    };
    $[22] = setTempState;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== errors.title || $[25] !== t11 || $[26] !== t12 || $[27] !== tempState.title) {
    t13 = <FormInput required={true} value={t10} label={t11} onChange={t12} error={errors.title} />;
    $[24] = errors.title;
    $[25] = t11;
    $[26] = t12;
    $[27] = tempState.title;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = tempState.buttonTitle;
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.store.item.button");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== setTempState) {
    t16 = t17 => {
      const {
        target: t18
      } = t17;
      const {
        value: value_0
      } = t18;
      return setTempState(prev_1 => ({
        ...prev_1,
        buttonTitle: value_0
      }));
    };
    $[31] = setTempState;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== errors.buttonTitle || $[34] !== t15 || $[35] !== t16 || $[36] !== tempState.buttonTitle) {
    t17 = <FormInput required={true} value={t14} label={t15} onChange={t16} error={errors.buttonTitle} />;
    $[33] = errors.buttonTitle;
    $[34] = t15;
    $[35] = t16;
    $[36] = tempState.buttonTitle;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t13 || $[39] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t13}{t17}</div>;
    $[38] = t13;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  const t19 = tempState.subTitle;
  let t20;
  if ($[41] !== t) {
    t20 = t("dashboard.store.item.subtitle");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== setTempState) {
    t21 = t22 => {
      const {
        target: t23
      } = t22;
      const {
        value: value_1
      } = t23;
      return setTempState(prev_2 => ({
        ...prev_2,
        subTitle: value_1
      }));
    };
    $[43] = setTempState;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== errors.subTitle || $[46] !== t20 || $[47] !== t21 || $[48] !== tempState.subTitle) {
    t22 = <FormTextarea required={true} value={t19} label={t20} onChange={t21} error={errors.subTitle} />;
    $[45] = errors.subTitle;
    $[46] = t20;
    $[47] = t21;
    $[48] = tempState.subTitle;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t18 || $[51] !== t22) {
    t23 = <div className="flex flex-col gap-5">{t18}{t22}</div>;
    $[50] = t18;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t23 || $[54] !== t9) {
    t24 = {
      key: "text",
      title: t9,
      element: t23
    };
    $[53] = t23;
    $[54] = t9;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("dashboard.store.item.collect_info");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== setTempState) {
    t26 = fields => setTempState(prev_3 => ({
      ...prev_3,
      fields
    }));
    $[58] = setTempState;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t26 || $[61] !== tempState.fields) {
    t27 = <StoreFields fields={tempState.fields} onChange={t26} initFields={optinInitFields} />;
    $[60] = t26;
    $[61] = tempState.fields;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== t25 || $[64] !== t27) {
    t28 = {
      key: "url",
      title: t25,
      element: t27
    };
    $[63] = t25;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t24 || $[67] !== t28 || $[68] !== t8) {
    t29 = <ItemSteps steps={[t8, t24, t28]} />;
    $[66] = t24;
    $[67] = t28;
    $[68] = t8;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  return t29;
};
export default OptinThumbnail;